import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import useTaskDataFromParams from './useTaskDataFromParams';
import {
  setInnerActivationOfChange,
  setLocalTask,
} from '../store/actions/calendarActions';
import { setItemToCalendar } from '../../../actions/itemToCalendar';
import TaskAddedNotificationContent, {
  taskAddedNotificationCN,
} from '../components/TaskAddedNotificationContent';

const createBaseNotificationConfig = ({ title, duration }) => {
  return { message: title, duration, className: taskAddedNotificationCN };
};

const createRequestsNotificationConfig = ({ title, onOk }) => {
  const config = createBaseNotificationConfig({ title, duration: 10 });

  const key = Date.now();

  const close = () => notification.close(key);

  const handleOk = () => {
    onOk();
    close();
  };

  return {
    ...config,
    key,
    btn: (
      <TaskAddedNotificationContent
        onCancel={close}
        onOk={handleOk}
      />
    ),
  };
};

const createCalendarNotificationConfig = ({ title }) => {
  return createBaseNotificationConfig({ title, duration: 5 });
};

const createNotificationConfig = ({ innerActivationOfChange, title, onOk }) =>
  innerActivationOfChange
    ? createCalendarNotificationConfig({ title })
    : createRequestsNotificationConfig({ title, onOk });

const selectInnerActivationOfChange = (state) =>
  state.newCalendarStore.innerActivationOfChange;

const useSuccessTaskMutation = (successMsg) => {
  const innerActivationOfChange = useSelector(selectInnerActivationOfChange);

  const { push } = useHistory();
  const dispatch = useDispatch();
  const { setRequestId } = useTaskDataFromParams();

  const handleSuccess = useCallback(() => {
    dispatch(setLocalTask(null));
    setRequestId('');
    dispatch(setItemToCalendar(null));
    dispatch(setInnerActivationOfChange(false));

    if (successMsg) {
      const config = createNotificationConfig({
        innerActivationOfChange,
        title: successMsg,
        onOk: () => push('/Requests'),
      });

      notification.success(config);
    }
  }, [successMsg, dispatch, setRequestId, push, innerActivationOfChange]);

  return handleSuccess;
};

export default useSuccessTaskMutation;
